import React, { Component } from 'react';
import { Tooltip, Icon } from 'antd';
import './style.less';

class HeaderBar extends Component {
    constructor(props) {
        super(props);
    }

    handleClick = (e) => {
        const target = e.target;
        const current = target.dataset.index;
        if (!current) {
            return;
        }
        this.props.onChange(Number(current));
    }

    render() {
        const { title, tip, icons = [], current } = this.props;
        return (
            <div className="header-bar">
                <div className="header-left">
                    {title}
                    {
                        tip &&
                        <Tooltip placement="right" title={tip}>
                            <Icon type="info-circle" />
                        </Tooltip>
                    }
                </div>
                <div className="header-right" onClick={this.handleClick}>
                    {
                        icons.filter((item, index) => index !== current)
                            .map(item => <i key={item.order} data-index={item.order} className="icon iconfont">{item.icon}</i>)
                    }
                </div>
            </div>
        );
    }
}

export default HeaderBar;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/components/HeaderBar/index.js